import React from 'react';
import { scenes } from '../data/site';
import { useActiveScene } from '../hooks/useActiveScene';
const sceneIds = scenes.map(scene => scene.id);
export function ReelProgress() {
  const active = useActiveScene(sceneIds);
  return <nav aria-label="Scenes" className="fixed right-4 top-1/2 z-40 hidden -translate-y-1/2 lg:block" data-id="element-32" data-mp="3uvgpip6pbyn1">
      <ul className="flex flex-col items-end gap-6" data-id="element-33" data-mp="3nko2msp4kpx">
        {scenes.map(scene => {
        const isActive = scene.id === active;
        return <li key={scene.id} className="group flex items-center gap-3" data-id="element-34" data-mp="3px5c64h77602">
              <span className={`font-mono text-[9px] uppercase tracking-[0.25em] transition-all duration-500 ${isActive ? 'text-brass opacity-100' : 'text-stone opacity-0 group-hover:opacity-100'}`} data-id="element-35" data-mp="3bxdvfvzarbid">
                {scene.label}
              </span>
              <a href={`#${scene.id}`} aria-label={`Go to ${scene.label}`} aria-current={isActive ? 'true' : undefined} className={`block h-2 w-2 rounded-full border transition-all duration-500 ${isActive ? 'scale-125 border-brass bg-brass' : 'border-cream/40 bg-transparent hover:border-cream'}`} data-id="element-36" data-mp="1f42kwo07gpd3" />
            </li>;
      })}
      </ul>
    </nav>;
}